import { useState } from 'react';
import { useActivateDeactiavateEmployeeMutation } from '../../features/apis/authApi';
import ReactToastify from '../../hooks/useReactToastify';
import BaseModal from '../Common/BaseModal';

type ActivationToggleModal = {
  profileUser: {
    name?: string;
    email?: string;
    _id: string;
    isActive: boolean;
  };
  isOpened: boolean;
  onClose: () => void;
  refetch: () => void;
};

const Activation: React.FC<ActivationToggleModal> = ({
  profileUser,
  isOpened,
  onClose,
  refetch,
}) => {
  const [loadingState, setLoadingState] = useState<boolean>(false);
  const [activateDeactivateEmployee] = useActivateDeactiavateEmployeeMutation();

  const activateDecativateHandler = async () => {
    setLoadingState(true);
    try {
      const response = await activateDeactivateEmployee({
        id: profileUser._id,
      }).unwrap();
      console.log(response, 'delete response');
      if (response) {
        refetch();
        setLoadingState(false);
        onClose();
        return ReactToastify({
          message: response.log,
          success: true,
        });
      }
    } catch (err: any) {
      setLoadingState(false);
      ReactToastify({
        message: `Unabale to ${
          profileUser?.isActive ? 'De-activate' : 'Activate'
        }  ${profileUser?.name}. Please Try Again`,
        success: false,
      });
    }
  };

  return (
    <BaseModal
      header={`You are ${
        !profileUser?.isActive ? 'Activating' : 'De-Activating'
      } ${profileUser?.name?.toUpperCase()}`}
      isOpen={isOpened}
      onClose={onClose}
      showWarning
      warningMessage={`Deactivating this user will prevent them from accessing the portal.`}
      isLoading={loadingState}
      onSubmit={activateDecativateHandler}
      submitText="Confirm"
    >
      <></>
    </BaseModal>
  );
};

export default Activation;
